export const Separator = () => {
    return (
        <svg width="38" height="2" viewBox="0 0 38 2" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect width="38" height="2" fill="#DD4F17" />
        </svg>
    );
};
